import React from 'react';
import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { DataContext } from './DataContextProvider.js';
import moment from 'moment';

export default function FiltersModal({show, close}) {
  const dataContext = React.useContext(DataContext);
  const [products, setProducts] = React.useState([]);
  const [invertProducts, setInvertProducts] = React.useState(false);
  const [defaultProducts, setDefaultProducts] = React.useState([]);
  const [teams, setTeams] = React.useState([]);
  const [invertTeams, setInvertTeams] = React.useState(false);
  const [defaultTeams, setDefaultTeams] = React.useState([]);
  const [authors, setAuthors] = React.useState([]);
  const [invertAuthors, setInvertAuthors] = React.useState(false);
  const [defaultAuthors, setDefaultAuthors] = React.useState([]);
  const [languages, setLanguages] = React.useState([]);
  const [invertLanguages, setInvertLanguages] = React.useState(false);
  const [defaultLanguages, setDefaultLanguages] = React.useState([]);
  const [humanLanguages, setHumanLanguages] = React.useState([]);
  const [invertHumanLanguages, setInvertHumanLanguages] = React.useState(false);
  const [defaultHumanLanguages, setDefaultHumanLanguages] = React.useState([]);
  const [countries, setCountries] = React.useState([]);
  const [defaultCountries, setDefaultCountries] = React.useState([]);
  const [enablePubRange, setEnablePubRange] = React.useState(dataContext.pubStart !== null);
  const [pubRange, setPubRange] = React.useState([dataContext.pubStart, dataContext.pubEnd]);
  const [lists, setLists] = React.useState([]);
  const [defaultLists, setDefaultLists] = React.useState([]);

  const [filters, setFilters] = React.useState(dataContext.globalFilters);

  const changeItems = (items, name, setDefault) => {
    filters[name] = items.map(item => item.value);
    if (filters[name].length === 0)
      delete filters[name];
    setDefault(items.filter(item => (dataContext.globalFilters[name] || []).indexOf(item.value) !== -1));
    setFilters(filters);
  };
  const changeProducts = items => changeItems(items, 'products', setDefaultProducts);
  const changeTeams = items => changeItems(items, 'teams', setDefaultTeams);
  const changeAuthors = items => changeItems(items, 'authors', setDefaultAuthors);
  const changeLanguages = items => changeItems(items, 'languages', setDefaultLanguages);
  const changeHumanLanguages = items => changeItems(items, 'humanLanguages', setDefaultHumanLanguages);
  const changeCountries = items => changeItems(items, 'countries', setDefaultCountries);
  const changeLists = items => changeItems(items, 'lists', setDefaultLists);

  const toggleInvert = (target, name, setInvert) => {
    setInvert(target.checked);
    if (target.checked) {
      filters[name] = true;
    }
    else {
      delete filters[name];
    }
    setFilters(filters);
  }
  const toggleInvertProducts = ev => toggleInvert(ev.target, 'productsInverted', setInvertProducts);
  const toggleInvertTeams = ev => toggleInvert(ev.target, 'teamsInverted', setInvertTeams);
  const toggleInvertAuthors = ev => toggleInvert(ev.target, 'authorsInverted', setInvertAuthors);
  const toggleInvertLanguages = ev => toggleInvert(ev.target, 'languagesInverted', setInvertLanguages);
  const toggleInvertHumanLanguages = ev => toggleInvert(ev.target, 'humanLanguagesInverted', setInvertHumanLanguages);

  const initialUpdate = React.useCallback((name, itemName, set, setDefault, setInvert) => {
    fetch('/api/' + name).then(data => data.json()).then(data => {
      const items = data.results.map(item => { return {value: item.id, label: item.name } });
      set(items);
      setDefault(items.filter(item => (dataContext.globalFilters[itemName] || []).indexOf(item.value) !== -1));
      if (setInvert && dataContext.globalFilters[itemName + 'Inverted']) {
        setInvert(true);
      }
    });
  }, [dataContext.globalFilters]);
  React.useEffect(() => initialUpdate('products', 'products', setProducts, setDefaultProducts, setInvertProducts), [initialUpdate]);
  React.useEffect(() => initialUpdate('teams', 'teams', setTeams, setDefaultTeams, setInvertTeams), [initialUpdate]);
  React.useEffect(() => initialUpdate('authors', 'authors', setAuthors, setDefaultAuthors, setInvertAuthors), [initialUpdate]);
  React.useEffect(() => initialUpdate('languages', 'languages', setLanguages, setDefaultLanguages, setInvertLanguages), [initialUpdate]);
  React.useEffect(() => initialUpdate('human_languages', 'humanLanguages', setHumanLanguages, setDefaultHumanLanguages, setInvertHumanLanguages), [initialUpdate]);
  React.useEffect(() => initialUpdate('countries', 'countries', setCountries, setDefaultCountries), [initialUpdate]);
  React.useEffect(() => initialUpdate('lists', 'lists', setLists, setDefaultLists), [initialUpdate]);

  const onKeyDown = (ev) => { if (ev.keyCode === 13) { ev.preventDefault(); } }
  const togglePubRange = () => { setEnablePubRange(!enablePubRange) };
  const changeDates = (ev, picker) => {
    setPubRange([picker.startDate.toDate(), picker.endDate.toDate()]);
  };

  const update = () => {
    dataContext.setGlobalFilters(filters);
    if (enablePubRange) {
      dataContext.setPubRange(pubRange[0], pubRange[1]);
    }
    else {
      dataContext.setPubRange(null, null);
    }
    dataContext.forceUpdate();
    close();
  };

  return (
    <Modal show={show} onHide={close} id="filters">
      <Modal.Header closeButton>
        <Modal.Title>Filters</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Products</Form.Label>
              <Form.Check defaultChecked={invertProducts} onClick={toggleInvertProducts} type="checkbox" label="Invert" style={{'float': 'right'}} />
              <Select isMulti isClearable options={products} onChange={changeProducts} defaultValue={defaultProducts} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Computer Languages</Form.Label>
              <Form.Check defaultChecked={invertLanguages} onClick={toggleInvertLanguages} type="checkbox" label="Invert" style={{'float': 'right'}} />
              <Select isMulti isClearable options={languages} onChange={changeLanguages} defaultValue={defaultLanguages} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Authors</Form.Label>
              <Form.Check defaultChecked={invertAuthors} onClick={toggleInvertAuthors} type="checkbox" label="Invert" style={{'float': 'right'}} />
              <Select isMulti isClearable options={authors} onChange={changeAuthors} defaultValue={defaultAuthors} />
            </Form.Group>
          </Col>
          <Col>
              <Form.Group>
                <Form.Label>Teams</Form.Label>
                <Form.Check defaultChecked={invertTeams} onClick={toggleInvertTeams} type="checkbox" label="Invert" style={{'float': 'right'}} />
                <Select isMulti isClearable options={teams} onChange={changeTeams} defaultValue={defaultTeams} />
              </Form.Group>
            </Col>
        </Row>
        {/*
        <Row>
         
          <Col>
            <Form.Group>
              <Form.Label>Human Languages</Form.Label>
              <Form.Check defaultChecked={invertHumanLanguages} onClick={toggleInvertHumanLanguages} type="checkbox" label="Invert" style={{'float': 'right'}} />
              <Select isMulti isClearable options={humanLanguages} onChange={changeHumanLanguages} defaultValue={defaultHumanLanguages} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Countries</Form.Label>
              <Select isMulti isClearable options={countries} onChange={changeCountries} defaultValue={defaultCountries} />
            </Form.Group>
            
          </Col>
          
        </Row>
        */}
        <Row>
          <Col>
            <Form.Group controlId="pubRange">
              <Form.Check defaultChecked={enablePubRange} onClick={togglePubRange} type="checkbox" label="Published between" />
              <DateRangePicker initialSettings={{
                startDate: dataContext.pubStart || new Date('2012-01-01'),
                endDate: dataContext.pubEnd || new Date(),
                showDropdowns: true,
                ranges: {
                  'Last 7 Days': [moment.utc().subtract(7, 'days'), moment.utc().subtract(1, 'days')],
                  'Last 30 Days': [moment.utc().subtract(30, 'days'), moment.utc().subtract(1, 'days')],
                  'This Month': [moment.utc().startOf('month'), moment.utc().subtract(1, 'days')],
                  'Last Month': [moment.utc().subtract(1, 'month').startOf('month'), moment.utc().subtract(1, 'month').endOf('month')],
                  'This Quarter': [moment.utc().startOf('quarter'), moment.utc().subtract(1, 'days')],
                  'Last Quarter': [moment.utc().subtract(1, 'quarter').startOf('quarter'), moment.utc().subtract(1, 'quarter').endOf('quarter')],
                  'This Year': [moment.utc().startOf('year'), moment.utc().subtract(1, 'days')],
                  'Last Year': [moment.utc().subtract(1, 'year').startOf('year'), moment.utc().subtract(1, 'year').endOf('year')],
                },
              }} onApply={changeDates} onHide={changeDates}>
                <input disabled={!enablePubRange} style={{color: (enablePubRange ? 'inherit' : 'transparent')}} type="text" className="form-control date-range" onKeyDown={onKeyDown} />
              </DateRangePicker>
            </Form.Group>
          </Col>
          <Col>
            {lists.length > 0 &&
            <Form.Group>
              <Form.Label>Lists</Form.Label>
              <Select isMulti isClearable options={lists} onChange={changeLists} defaultValue={defaultLists} />
            </Form.Group>
            }
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={close}>Cancel</Button>
        <Button variant="primary" onClick={update}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
